import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import moment from 'moment';
import 'moment/locale/zh-cn';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { defineComponent, ref } from 'vue';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { useRoute, useRouter } from 'vue-router';
import { isLogin, SHOW_BRAND } from '@/utils';
export default defineComponent({
  setup: function setup() {
    var _route$meta;

    var userService = useService(UserService);
    var route = useRoute();
    var router = useRouter();
    var loading = ref((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.auth);
    userService.init().then(function () {
      if (route.meta.auth && isLogin() === false) {
        var replaceUrl = SHOW_BRAND ? {
          name: 'Home'
        } : '/activity/list';
        router.replace(replaceUrl);
        loading.value = false;
      } else {
        loading.value = false;
      }
    }); // 解决合肥投诉品牌事件 2024-03-21
    // if (SHOW_BRAND) {
    //   // 如果可以展示品牌信息，就修改title
    //   document.title = '核桃编程_世界机器人冠军带孩子学编程';
    // }

    return {
      locale: zhCN,
      moment: moment,
      loading: loading
    };
  }
});